import Vue from 'vue';

export default {
  async fetchMacroActivitiesByDprId({ commit }, dprId) {
    return Vue.axios.get(Vue.$url("vessel-macro-activity-db/" + dprId))
      .then((rsp) => commit("SET_MACRO_ACTIVITIES", rsp.data))
  }
}